import { Skeleton } from "../ui/skeleton";

export function ListSkeleton() {
  return (
    <div className="container flex h-full flex-col gap-4 overflow-y-hidden md:p-4">
      <Skeleton className="h-[216px] rounded-none shadow-sm md:h-[180px] md:rounded-xl" />
      <div className="flex flex-1 flex-col gap-2 divide-y divide-neutral-400 px-2 pb-4 md:gap-0 md:rounded-[18px] md:p-0">
        <Skeleton className="h-20 rounded-[20px] shadow-sm md:rounded-b-none md:rounded-t-[20px]" />
        <Skeleton className="h-20 rounded-[20px] shadow-sm md:rounded-none" />
        <Skeleton className="h-20 rounded-[20px] shadow-sm md:rounded-none" />
        <Skeleton className="h-20 rounded-[20px] shadow-sm md:rounded-none" />
        <Skeleton className="h-20 rounded-[20px] shadow-sm md:rounded-none" />
        <Skeleton className="h-20 rounded-[20px] shadow-sm md:rounded-none" />
        <Skeleton className="h-20 rounded-[20px] shadow-sm md:rounded-none" />
        <Skeleton className="h-20 rounded-[20px] shadow-sm md:rounded-b-[20px] md:rounded-t-none" />
      </div>
    </div>
  );
}
export function FavoritesListSkeleton() {
  return (
    <div className="container flex h-full flex-col gap-4 overflow-y-hidden md:p-4">
      <Skeleton className="h-[132px] rounded-none shadow-sm md:rounded-xl" />
      <div className="flex flex-1 flex-col gap-2 divide-y divide-neutral-400 px-2 pb-4 md:gap-0 md:rounded-[18px] md:p-0">
        <Skeleton className="h-20 rounded-[20px] shadow-sm md:rounded-b-none md:rounded-t-[20px]" />
        <Skeleton className="h-20 rounded-[20px] shadow-sm md:rounded-none" />
        <Skeleton className="h-20 rounded-[20px] shadow-sm md:rounded-none" />
        <Skeleton className="h-20 rounded-[20px] shadow-sm md:rounded-none" />
        <Skeleton className="h-20 rounded-[20px] shadow-sm md:rounded-none" />
        <Skeleton className="h-20 rounded-[20px] shadow-sm md:rounded-none" />
        <Skeleton className="h-20 rounded-[20px] shadow-sm md:rounded-none" />
        <Skeleton className="h-20 rounded-[20px] shadow-sm md:rounded-b-[20px] md:rounded-t-none" />
      </div>
    </div>
  );
}

export function AdminListSkeleton() {
  return (
    <div className="flex h-full flex-1 grow flex-col gap-2 divide-y divide-neutral-400 pt-4 md:gap-0 md:rounded-[18px]">
      <Skeleton className="h-20 rounded-[20px] shadow-sm md:rounded-b-none md:rounded-t-[20px]" />
      <Skeleton className="h-20 rounded-[20px] shadow-sm md:rounded-none" />
      <Skeleton className="h-20 rounded-[20px] shadow-sm md:rounded-none" />
      <Skeleton className="h-20 rounded-[20px] shadow-sm md:rounded-none" />
      <Skeleton className="h-20 rounded-[20px] shadow-sm md:rounded-none" />
      <Skeleton className="h-20 rounded-[20px] shadow-sm md:rounded-b-[20px] md:rounded-t-none" />
    </div>
  );
}
